import React from 'react';
import styled, { css } from 'styled-components';
import arrowRight from 'images/icon/arrow_right-14x24.png';
import arrowLeft from 'images/icon/arrow_left-14x24.png';

export default function CalendarHeader({
    currDate,
    onClickNext,
    onClickPrev,
    selectDay
}) {
    const currentDate = currDate.split('-');
    if(selectDay) return null;
    return (
        <CalendarHeaderBlock>
                <CalendarHeaderCurrDate>
                    <CurrentYearTxt>{`${currentDate[0]}년`}</CurrentYearTxt>
                    <CurrentMonthTxt>{`${currentDate[1]}월`}</CurrentMonthTxt>
                </CalendarHeaderCurrDate>
                <CalendarArrowButtonBlock>
                    <ArrowLeftButton onClick={onClickPrev}>
                        <ArrowIcon src={arrowLeft}/>
                    </ArrowLeftButton>
                    <ArrowRightButton onClick={onClickNext}>
                        <ArrowIcon src={arrowRight}/>
                    </ArrowRightButton>
                </CalendarArrowButtonBlock>
        </CalendarHeaderBlock>
    );
}

const CalendarHeaderBlock = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: calc(100vw * (32 / 375));
    padding: 0 calc(100vw * (28 / 375));
`;

const CalendarHeaderCurrDate = styled.div`
    font-size: calc(100vw * (22 / 375));
    line-height: calc(100vw * (31.86 / 375));
`;

const CurrentYearTxt = styled.span`
    font-weight: 400;
`;

const CurrentMonthTxt = styled.span`
    font-weight: 700;
    margin-left: calc(100vw * (5 / 375));
`;

const CalendarArrowButtonBlock = styled.div`
    display: flex;
`;

const arrowButton = css`
    width: calc(100vw * (7 / 375));
    height: calc(100vw * (12 / 375));
`;

const ArrowRightButton = styled.button`
    ${arrowButton}
`;

const ArrowLeftButton = styled.button`
    ${arrowButton}
    margin-right: calc(100vw * (30 / 375));
`;

const ArrowIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
